import swiggle from "../../images/swiggle.svg"
import "./hero.css"

export default function Hero() {
    return (
        <div className="hero">
            <p className="hero-text">{'Hi. I\'m Smit.'}</p>
            <p className="hero-text">{'An Aspiring Software Engineer.'}</p>
            <img className="hero-swiggle" src={swiggle} alt='swiggle' />
        </div>
    )
}